import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const fetchProgramManagersWorkload = (
  setWorkload: Function,
  setIsLoading: Function,
  onlyActive: boolean = true,
  language: string
) => {
  setIsLoading(true);
  ApiService.get(`cohorts/workload/program-managers?order=desc&only_active=${onlyActive}`)
    .then((response) =>
      setWorkload(
        response.data.cohorts_program_managers_workload.map((element: any, index: number) => ({
          ...element,
          index: index + 1,
        }))
      )
    )
    .catch((error) => {
      console.error("Error fetching program managers workload:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setIsLoading(false));
};
